/**
 * Aspid / catalog: фильтры сайдбара, сортировка, вид сетки/списка,
 * догрузка страниц через /ajax/product/list. Первая страница уже
 * отрендерена сервером, параметры лежат в data-* #catalogApp.
 * Фильтры меняют URL (history.replaceState) и перерисовывают сетку.
 */
const { api, t, price, notify, reveal } = window.rt;

const app = document.getElementById('catalogApp');

if( app ) {

    const grid     = app.querySelector('[data-products]');
    const empty    = document.getElementById('emptyState');
    const moreWrap = app.querySelector('[data-load-more]');
    const sortEl   = document.getElementById('sortSelect');
    const fromEl   = document.getElementById('priceFrom');
    const toEl     = document.getElementById('priceTo');

    const query = {
        category:   Number( app.dataset.category ),
        search:     app.dataset.search,
        page:       Number( app.dataset.page ),
        pages:      Number( app.dataset.pages ),
        order_by:   app.dataset.orderBy,
        order:      app.dataset.order,
        price_from: Number( app.dataset.priceFrom ),
        price_to:   Number( app.dataset.priceTo ),
    };

    if( sortEl )
        sortEl.value = query.order_by + ':' + query.order;

    function escape( text ) {

        return String( text ).replace( /[&<>"']/g, ch => ( {
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
        } )[ ch ] );
    }

    function card( item ) {

        const image = item.image_thumb || ( window.baseURL + '/templates/Aspid/assets/images/placeholder.svg' );
        const cost  = item.sale_price > 0 ? item.sale_price : item.price;

        return `
        <div class="p-card reveal" data-product-id="${ item.id }">
            <div class="p-card-img">
                <div class="p-badge">
                    ${ item.in_stock ? `<span class="badge-stock">${ t('common.in_stock') }</span>` : `<span class="badge-order">${ t('common.on_order') }</span>` }
                </div>
                <a class="p-card-quick" href="${ window.baseURL }/${ escape( item.slug ) }" title="${ t('common.more') }">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                </a>
                <a href="${ window.baseURL }/${ escape( item.slug ) }"><img src="${ escape( image ) }" alt="${ escape( item.title ) }" loading="lazy"></a>
            </div>
            <div class="p-card-body">
                <h3><a href="${ window.baseURL }/${ escape( item.slug ) }">${ escape( item.title ) }</a></h3>
                <div class="p-card-footer">
                    <div class="p-price">${ price( cost, false ) }<small>${ window.shop.currencySuffix }</small></div>
                    <button class="p-add-btn" type="button" data-action="cart-add" data-product-id="${ item.id }">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
                        ${ t('catalog.add_to_cart') }
                    </button>
                </div>
            </div>
        </div>`;
    }

    function syncUrl() {

        const params = new URLSearchParams();

        if( query.search ) params.set( 'search', query.search );
        if( query.order_by !== 'created_at' ) params.set( 'order_by', query.order_by );
        if( query.order !== 'desc' ) params.set( 'order', query.order );
        if( query.price_from > 0 ) params.set( 'price_from', query.price_from );
        if( query.price_to > 0 ) params.set( 'price_to', query.price_to );
        if( query.page > 1 ) params.set( 'page', query.page );

        const qs = params.toString();

        history.replaceState( null, '', location.pathname + ( qs ? '?' + qs : '' ) );
    }

    async function load( append = false ) {

        app.classList.add('is-loading');

        try {

            const data = await api.get( 'product/list', {
                category:   query.category,
                search:     query.search,
                page:       query.page,
                order_by:   query.order_by,
                order:      query.order,
                price_from: query.price_from,
                price_to:   query.price_to,
            } );

            const html = data.items.map( card ).join('');

            if( append )
                grid.insertAdjacentHTML( 'beforeend', html );
            else
                grid.innerHTML = html;

            query.pages = Number( data.num_of_pages );

            if( empty )
                empty.hidden = data.total > 0;

            if( moreWrap )
                moreWrap.hidden = query.page >= query.pages;

            const count = app.querySelector('.catalog-page-count');

            if( count )
                count.textContent = t( 'common.items', { n: data.total } );

            reveal( grid );
            syncUrl();

        } catch( e ) {
            notify( e.message, 'error' );
        }

        app.classList.remove('is-loading');
    }

    app.addEventListener( 'click', ( event ) => {

        const el = event.target.closest('[data-action]');

        if( ! el )
            return;

        switch( el.dataset.action ) {

            case 'filter-apply':
                query.price_from = Math.max( 0, Math.round( Number( fromEl?.value || 0 ) * 100 ) );
                query.price_to   = Math.max( 0, Math.round( Number( toEl?.value || 0 ) * 100 ) );
                query.page       = 1;
                load();
                break;

            case 'filter-reset':
                if( fromEl ) fromEl.value = '';
                if( toEl ) toEl.value = '';
                if( sortEl ) sortEl.value = 'created_at:desc';
                query.price_from = 0;
                query.price_to   = 0;
                query.order_by   = 'created_at';
                query.order      = 'desc';
                query.page       = 1;
                load();
                break;

            case 'load-more':
                if( query.page < query.pages ) {
                    query.page++;
                    load( true );
                }
                break;

            case 'sidebar-toggle':
                document.getElementById('sidebar')?.classList.toggle('open');
                break;

            case 'view-grid':
            case 'view-list':
                app.querySelectorAll('.view-btn').forEach( b => b.classList.remove('active') );
                el.classList.add('active');
                grid.classList.toggle( 'list-view', el.dataset.action === 'view-list' );
                break;
        }
    } );

    sortEl?.addEventListener( 'change', () => {

        [ query.order_by, query.order ] = sortEl.value.split(':');
        query.page = 1;
        load();
    } );
}
